import React from "react";
import DeviceComponent from "./components/device.component";
import ReviewUsedComponent from "./components/review.component";
import { useCreateUsedContext } from "./provider/createUsed.provider";

const CreateUsedMiCeluComponent = () => {
  const { step } = useCreateUsedContext();
  return (
    <>
      {step === 1 && <DeviceComponent />}
      {step === 2 && <ReviewUsedComponent />}
    </>
  );
};
export default CreateUsedMiCeluComponent;
